import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

const TRUST_ITEMS = [
  { icon: VerifiedUserOutlinedIcon, title: '100% Verified Guides', desc: 'Every guide is verified before going live' },
  { icon: LocalOfferOutlinedIcon, title: 'Best Price Guarantee', desc: 'Get the best rates available' },
  { icon: LockOutlinedIcon, title: 'Secure Booking', desc: 'Your payment is protected' },
  { icon: SupportAgentOutlinedIcon, title: '24/7 Support', desc: "We're here to help you" },
];

export function TrustBar() {
  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 0, md: 0 },
        pb: { xs: 6, md: 8 },
        bgcolor: '#FFFFFF',
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            bgcolor: 'common.white',
            borderRadius: '16px',
            boxShadow: '0 4px 24px rgba(15, 23, 42, 0.06)',
            border: '1px solid #E2E8F0',
            px: { xs: 2.5, md: 4 },
            py: { xs: 2.5, md: 3 },
          }}
        >
          <Grid container spacing={{ xs: 2.5, md: 0 }} columns={12}>
            {TRUST_ITEMS.map((item, index) => (
              <Grid key={item.title} size={{ xs: 12, sm: 6, md: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1.5,
                    pr: { md: index < TRUST_ITEMS.length - 1 ? 2 : 0 },
                    pb: {
                      xs: index < TRUST_ITEMS.length - 1 ? 0 : 0,
                      sm: 0,
                    },
                  }}
                >
                  <item.icon sx={{ fontSize: 24, color: '#2563EB', flexShrink: 0, mt: 0.1 }} />
                  <Box>
                    <Typography
                      sx={{
                        fontSize: '0.8125rem',
                        fontWeight: 600,
                        color: '#0F172A',
                        lineHeight: 1.35,
                        mb: 0.25,
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography sx={{ fontSize: '0.75rem', color: '#64748B', lineHeight: 1.5 }}>
                      {item.desc}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}
